const NOTE_LABEL_PREVIEW_WORD_COUNT = 6;

export function getDeleteNoteAriaLabel(noteText: string): string {
  const words = noteText.trim().split(/\s+/);
  const preview = words.slice(0, NOTE_LABEL_PREVIEW_WORD_COUNT).join(" ");
  const suffix = words.length > NOTE_LABEL_PREVIEW_WORD_COUNT ? "…" : "";
  return `Delete note: ${preview}${suffix}`;
}
